import { ChangeDetectionStrategy, Component } from '@angular/core';

@Component({
  selector: 'vc-search-input',
  templateUrl: './search-input.component.html',
  styleUrl: './search-input.component.scss',
  standalone: false,
  changeDetection: ChangeDetectionStrategy.OnPush
})
export class VcSearchInputComponent {

}
